import {NavigationGuardNext, RouteLocationNormalized} from "vue-router";
import AuthController from "@/controllers/global/AuthController";
import AuthMiddleware from "@/router/middleware/AuthMiddleware";
import {ModuleList} from "@/models/settings/ModuleList";
import {PermissionList} from "@/models/settings/PermissionList";

/**
 * @note AuthMiddleware must be called before AdminAuthMiddleware!
 */
export default class UserAuthMiddleware extends AuthMiddleware {
    public moduleId: ModuleList;
    public permissionId: PermissionList;

    constructor(moduleId: ModuleList, permissionId: PermissionList) {
        super();
        this.moduleId = moduleId;
        this.permissionId = permissionId;
    }

    public async execute(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
        try {
            if (AuthController.hasUserAccess(this.moduleId, this.permissionId)) {
                return true;
            } else {
                next({name: "moduleAccessDenied"});
                return false;
            }
        } catch (error: any) {
            console.error("user auth error: ", error);
            return false;
        }
    }
}
